import { useCallback } from "react";

import type * as Repository from "../../../_repository";
import type * as Type from "../type";

type Props = {
	queryData: Repository.Query.QueryData.OptionPmsOptionListQueryData;
};

export const useViewDataConverter = () => {
	const onConvertViewData = useCallback(({ queryData }: Props): Type.ViewData => {
		return {
			options: queryData.optionPmsOptionList.options.map(({ optionID, name }) => ({
				id: optionID,
				label: name,
				checked: false,
			})),
			displayAll: true,
		} satisfies Type.ViewData;
	}, []);

	return {
		onConvertViewData,
	};
};
